import { defineMessages } from "react-intl";

export const scope = "components.MarketPositions";

export const messages = defineMessages({
  totalVolume: {
    id: `${scope}.totalVolume`,
    defaultMessage: "Total en cartera",
  },
  warningText: {
    id: `${scope}.warningText`,
    defaultMessage:
      "Por el momento solo podrás gestionar {br} tus inversiones desde un agente",
  },
  assetLabel: {
    id: `${scope}.assetLabel`,
    defaultMessage: "Activo",
  },
  amountLabel: {
    id: `${scope}.amountLabel`,
    defaultMessage: "Cantidad",
  },
  priceLabel: {
    id: `${scope}.priceLabel`,
    defaultMessage: "Precio",
  },
  valuationLabel: {
    id: `${scope}.valuationLabel`,
    defaultMessage: "Valuación",
  },
  percentageLabel: {
    id: `${scope}.percentageLabel`,
    defaultMessage: "Porcentaje",
  },
  currencies: {
    id: `${scope}.currencies`,
    defaultMessage: "Monedas",
  },
  emptyStatePositions: {
    id: `${scope}.emptyStatePositions`,
    defaultMessage:
      "Tu cartera no tiene inversiones por el momento.{br}<b>Escribíle por whatsapp a tu agente para operar.</b>",
  },
});
